// The rule-specific terms one family takes, picked by family.
//
// ONE switch. The headline blocks and the rules editor both render a rule's own
// terms, and a second copy of this table would let the two drift apart.

import { Show, type JSX } from 'solid-js';
import { Dynamic } from 'solid-js/web';

import type { RuleBuilderState } from '../../core/ruleRegistry';
import {
  DailyLossParams,
  RiskPerTradeParams,
  TotalDrawdownParams,
  TotalExposureParams,
  TotalUnrealizedLossParams,
  TrailingDrawdownParams,
} from './RiskLimitParams';
import {
  FlatByScheduleParams,
  InstrumentListParams,
  NewsTradingParams,
  TradingHoursParams,
  WeekendHoldingParams,
} from './TradingRestrictionParams';

interface RuleParamsProps {
  rule: RuleBuilderState;
  onUpdateParams: (params: Record<string, unknown>) => void;
}

const EDITORS: Record<string, (props: RuleParamsProps) => JSX.Element> = {
  max_daily_loss: DailyLossParams,
  max_total_drawdown: TotalDrawdownParams,
  max_trailing_drawdown: TrailingDrawdownParams,
  max_risk_per_trade: RiskPerTradeParams,
  max_total_unrealized_loss: TotalUnrealizedLossParams,
  max_total_exposure: TotalExposureParams,
  trading_hours: TradingHoursParams,
  weekend_holding: WeekendHoldingParams,
  flat_by_schedule: FlatByScheduleParams,
  news_trading: NewsTradingParams,
  instrument_whitelist: InstrumentListParams,
  instrument_blacklist: InstrumentListParams,
};

/** Nothing for a family whose terms are the common fields and nothing else. */
export default function RuleParams(props: RuleParamsProps) {
  return (
    <Show when={EDITORS[props.rule.ruleType]}>
      {(editor) => <Dynamic component={editor()} rule={props.rule} onUpdateParams={props.onUpdateParams} />}
    </Show>
  );
}
